export default __webpack_public_path__ + "static/media/notes.974dcc64.svg";